"use client";
import "./../styles/home.css";
import React from 'react';
import { useEffect, useState } from "react";

const Home = () => {
  const images = [{ src: "/assets/banner.png", alt: "首页" }];
  const advantages = [
    {
      src: "/assets/advantage.png",
      alt: "Image 1",
      title: "技术创新与领导力",
      content:
        "我们公司技术创新领先，拥有涵盖多领域的庞大专利组合，为产品和服务提供坚实的知识产权保护。我们每年大量投资研发，确保技术领先优势。",
    },
    {
      src: "/assets/advantage.png",
      alt: "Image 1",
      title: "专业团队与人才优势",
      content:
        "我们公司拥有精英团队，成员包括行业专家、技术大牛和资深顾问，他们专业背景深厚，经验丰富，擅长解决复杂问题。团队多学科交叉，优势互补，阵容强大。",
    },
    {
      src: "/assets/advantage.png",
      alt: "Image 1",
      title: "优质服务与客户满意度",
      content:
        "我们建立了7*24不间断的快速响应机制，确保客户问题得到即时响应，任何需求都能在最短时间内得到满足；以及定期客户回访，深入了解客户需求变化，持续优化服务。",
    },
    {
      src: "/assets/advantage.png",
      alt: "Image 1",
      title: "成本控制与性价比",
      content:
        "	我们公司在软件开发中实施高效成本控制，采用敏捷开发、CI/CD提升效率，减少迭代成本。与优质云服务商、工具供应商合作，利用开源资源，降低开发与运维成本，为客户提供更具竞争力的价格。",
    },
    {
      src: "/assets/advantage.png",
      alt: "Image 1",
      title: "灵活性与定制化服务",
      content:
        "我们擅长定制解决方案，满足客户需求。快速适应市场，优化服务流程，确保客户享受前沿软件服务。",
    },
  ];
  return (
    <>
      <div className="carousel">
        <div className="carousel-inner">
          <img src="/assets/banner.png" alt="首页" />
        </div>
      </div>
      <BodyTop />
      {/* <SolarSystem></SolarSystem> */}
      <BodyMiddle advantages={advantages} />
      <BodyBottom />
    </>
  );
};

const BodyTop = () => {
  return (
    <div className="body-top">
      <div className="body-top-title">为什么选择云网</div>
      <div className="body-top-subTitle">
        合作共赢，为合作伙伴提供更优质的解决方案
      </div>
      <div className="body-top-3d">
        <img src="/assets/system.png" alt="优势" />
      </div>
    </div>
  );
};

const BodyMiddle = ({ advantages }) => {
  return (
    <div className="body-middle">
      <div className="body-middle-title">我们的优势</div>
      <div className="body-middle-subTitle">
        合作共赢，为合作伙伴提供更优质的解决方案
      </div>
      <div className="body-middle-bottom">
        {advantages.map((item, index) => (
          <div key={index} className="advantageItem">
            <img src={item.src} alt={item.alt} />

            <div className="advantageItemTitle">{item.title}</div>
            <div className="advantageItemContent">{item.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const BodyBottom = () => {
  return (
    <div className="body-bottom">
      <div className="body-bottom-title">携手共赢，与合作伙伴共建未来</div>
      <div className="body-bottom-subTitle">
        合作共赢，为合作伙伴提供更优质的解决方案
      </div>
      <div className="body-bottom-bottom">
        {/* {businessPartners.map((item, index) => ( */}
        {/* // <div key={index} className="partnerItem"> */}
        <img src="/assets/partner.png" alt="合作伙伴" />
        {/* // </div> */}
        {/* ))} */}
      </div>
    </div>
  );
};

export default Home;
